import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Icon from '@amzn/meridian/icon';
import arrowLeftLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-left-large';
import Link from '@amzn/meridian/link';
import { useNavigate } from 'react-router-dom';
import Box from '@amzn/meridian/box';

import { renderUrl } from '../../config/Url';
import { FormattedMessage } from 'react-intl';

interface IBackButtonProps {
  isBig?: boolean;
  backURL: string;
  history?: any;
}

const BackButton: React.FC<IBackButtonProps> = ({ isBig = true, backURL }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Column spacingInset='median' width={isBig ? '50%' : '100%'}>
        <Row spacingInset='400'>
          <Icon tokens={arrowLeftLargeTokens} />
          <Link
            href={renderUrl(backURL)}
            onClick={navigate}
            type='secondary'
            data-csa-c-type='element'
            data-csa-c-slot-id='back-button-navigation-slot'
            data-csa-c-content-id='back-button-navigation-back-link'
          >
            <FormattedMessage
              id='cs_perfportal_navigate_back'
              defaultMessage='Back'
              description='Link to go back'
            />
          </Link>
        </Row>
      </Column>
    </Box>
  );
};

BackButton.displayName = 'BackButton';

export default BackButton;
